import { render, staticRenderFns } from "./LegalEntitiesInvoiceRequest.vue?vue&type=template&id=4bac3758"
import script from "./LegalEntitiesInvoiceRequest.vue?vue&type=script&lang=js"
export * from "./LegalEntitiesInvoiceRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports